/* tslint:disable */
/* eslint-disable */
/**
 * ECSF Platform API
 * ## Date and time conventions  - Timestamps are UTC in ISO-8601 format (e.g. `2026-08-23T22:00:00Z`). - Fields that represent a calendar day (e.g. `activationDate`, `consentEndDate`, `billingPeriodFrom`) are date-only values in `yyyy-MM-dd` format. They are **always** days in the **Europe/Vienna** timezone, never UTC days. Where such a day is stored as a timestamp, it is anchored at the Vienna start of day, e.g. `2026-08-24` becomes `2026-08-23T22:00:00Z` during CEST. - Time ranges are half-open `[from, to)` — `from` inclusive, `to` exclusive.  ## Table filters  Endpoints that return table rows take a `RowsRequestDto` whose `filters` are `{ \"id\": \"<property>\", \"value\": <value> }` objects. The shape of `value` depends on the property:  - Text: a string, matched case-insensitively as a substring. - Number / id: a number, or an array of numbers to match any of them. - Boolean: `true` or `false`. - Enum: an array of enum values to match any of them. - Number range: `[min, max]`, both inclusive; either may be `null`. - Date / time range: `[from, to]` as ISO-8601 timestamps, applied as the half-open range `[from, to)`; either may be `null` (open-ended). To filter whole Vienna days, send the Vienna start of the first day as `from` and the Vienna start of the day **after** the last day as `to`, e.g. `[\"2026-10-04T22:00:00Z\", \"2026-10-05T22:00:00Z\"]` for 2026-10-05. For calendar-day columns both bounds are converted to Vienna days before comparing.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

export const operationServerMap: ServerMap = {
}
